/*
 *             Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
import _0xb091a1 from'../../message.js';class GetDocumentDetailsMessage extends _0xb091a1{constructor(_0x18a3ed){super(),this['documentId']=_0x18a3ed;}get['data'](){return{'documentId':this['documentId']};}['toJSON'](){return{'documentId':this['documentId']};}static['fromJSON'](_0x16bdb2){return new GetDocumentDetailsMessage(_0x16bdb2['documentId']);}}GetDocumentDetailsMessage['TYPE']='14',GetDocumentDetailsMessage['READABLE_TYPE_NAME']='getDocumentDetails',GetDocumentDetailsMessage['DESCRIPTOR_NAME']='GetDocumentDetailsMessage',GetDocumentDetailsMessage['DESCRIPTOR']={'fields':{'documentId':{'type':'string','id':0x1},'environmentId':{'type':'string','id':0x2}}};export default GetDocumentDetailsMessage;